const EllipsisIcon = () => {
  return (
    <div>
      <svg style={{display: "block"}} width="12" height="3" viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="1.5" cy="1.5" r="1.5" />
        <circle cx="6" cy="1.5" r="1.5" />
        <circle cx="10.5" cy="1.5" r="1.5" />
      </svg>
    </div>
  )
}

export default EllipsisIcon